module.exports = __webpack_public_path__ + "static/media/report-line.104fe7e2.svg";